import AppointmentSample from "@/assets/images/steper/appointment-sample.png";
import StepAppointment from "@/assets/images/steper/appointment.svg";
import { Image, List, Stack, Text, Title } from "@mantine/core";
import { useSetState } from "@mantine/hooks";
import { useEffect } from "react";
import Joyride, { Step } from "react-joyride";

interface State {
  run: boolean;
  steps: Step[];
}

type Props = {
  run: boolean;
  setRun: (e: boolean) => void;
};

function SchedulePageStepper({ run, setRun }: Props) {
  const [{ steps }] = useSetState<State>({
    run: false,
    steps: [
      {
        content: (
          <Stack>
            <Title order={3}> به نوبت دهی خوش آمدید! </Title>
            <Text ta="center">
              با ماژول نوبت دهی میتونی نوبت هاتو مدیریت کنی ، برای مشتریان خودت
              نوبت ثبت کنی و نوبت هاتو مدیریت کنی.
            </Text>
            <Title order={3}>بزن بریم بهت بگم چیا داریم!</Title>
            <Stack h="80">
              <Image src={StepAppointment} w={100} fit="contain" mx="auto" />
            </Stack>
          </Stack>
        ),
        placement: "center",
        target: "body",
      },
      {
        content: (
          <Stack>
            <Title order={4}>تقویم نمایشی نوبت ها</Title>
            <List ta="right">
              <List.Item>
                <Text>هر ردیف نمایش دهنده ساعت توی روز انتخابی هست</Text>
              </List.Item>
              <List.Item>
                <Text>
                  میتونی نوبت هاتو زیر هم توی هر ساعت مشخص مشاهده و مدیریت کنی
                </Text>
              </List.Item>
            </List>

            <Stack h="100">
              <Image src={AppointmentSample} w={200} fit="contain" mx="auto" />
            </Stack>
          </Stack>
        ),

        spotlightPadding: 10,
        target: "#panel",
      },
      {
        content: (
          <Stack>
            <Title order={5}>
              با کلیک بر روی این گزینه برای مشتری هات نوبت ثبت کنی
            </Title>
            {/* <Stack h="80">
              <Image src={StepDiscount} w={100} fit="contain" mx="auto" />
            </Stack> */}
          </Stack>
        ),
        spotlightPadding: 10,
        target: "#add-appointment",
      },
      {
        content: (
          <Stack>
            <Title order={5}>
              میتونی نوبت روزهای قبل و بعد رو از اینجا مشاهده کنی
            </Title>
          </Stack>
        ),
        spotlightPadding: 10,
        target: "#day-handler",
      },
      {
        content: (
          <Stack>
            <Title order={5}>
              میتونی با انتخاب این گزینه به روز مورد نظر خودت بری
            </Title>
          </Stack>
        ),

        spotlightPadding: 10,
        target: "#select-day",
      },
      {
        content: (
          <Stack>
            <Title order={5}>
              برای تغییر نمایش نوبت ها و یا افزودن سرویس از منو استفاده کن
            </Title>
          </Stack>
        ),

        spotlightPadding: 10,
        target: "#menu",
      },
    ],
  });

  useEffect(() => {
    const isRun = localStorage.getItem("tour-appointment");
    if (!isRun) setRun(true);
  }, []);

  return (
    <Joyride
      continuous
      run={run}
      scrollToFirstStep
      showSkipButton
      spotlightClicks
      callback={(data) => {
        const { status, action } = data;
        if (
          status === "finished" ||
          status === "skipped" ||
          action === "close"
        ) {
          setRun(false); // Reset the tour if finished or skipped
          localStorage.setItem("tour-appointment", "true");
        }
      }}
      locale={{
        back: "قبلی",
        close: "بستن",
        last: "آخرین",
        next: "بعدی",
        nextLabelWithProgress: "بعدی (مرحله {step} از {steps})",
        open: "باز گردن",
        skip: "بستن",
      }}
      steps={steps}
      styles={{
        overlay: {
          padding: 0,
          margin: 0,
        },
        buttonNext: {
          background: "var(--mantine-color-blue-9)",
        },
        buttonBack: {
          color: "var(--mantine-color-blue-9)",
        },
        options: {
          zIndex: 10000,
        },
        beacon: {
          display: "none",
        },
      }}
    />
  );
}

export default SchedulePageStepper;
